// Copyright (c) 2020 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file wisetime/type/site_ref.proto (package wisetime.type, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file wisetime/type/site_ref.proto.
 */
export const file_wisetime_type_site_ref: GenFile = /*@__PURE__*/
  fileDesc("Chx3aXNldGltZS90eXBlL3NpdGVfcmVmLnByb3RvEg13aXNldGltZS50eXBlIjcKB1NpdGVSZWYSCgoCaWQYASABKAkSFAoMZGlzcGxheV9uYW1lGAMgASgJSgQIAhADUgRuYW1lQicKFWNvbS53aXNldGltZS5hcGkudHlwZUIMU2l0ZVJlZlByb3RvUAFiBnByb3RvMw");

/**
 * A reference to a user's private site or one of their destination sites.
 *
 * @generated from message wisetime.type.SiteRef
 */
export type SiteRef = Message<"wisetime.type.SiteRef"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string;
};

/**
 * Describes the message wisetime.type.SiteRef.
 * Use `create(SiteRefSchema)` to create a new message.
 */
export const SiteRefSchema: GenMessage<SiteRef> = /*@__PURE__*/
  messageDesc(file_wisetime_type_site_ref, 0);

